import { useEffect } from 'react';
import { useRouteHelper } from './use-route-helper';
import { autorun, when } from 'mobx';

import { useStore } from 'core/store';
import { get, policyTypes } from 'core/helpers/lookups';
import { brandConstants } from 'brand-config';

const getPolicyType = get(policyTypes);

export const useTabText = () => {
  const {
    inPolicyRoute,
    inOfferEditRoute,
    inUWFormRoute,
    inOfferCheckoutRoute,
    inCustomerRoute,
    inNewQuoteRoute,
    inToolsRoutes,
    inSearchOffers,
    inSearchCustomers,
    inSearchPolicies,
    inAgencyPortal,
    inSignInRoute,
    inBranchPlusPolicy
  } = useRouteHelper();
  const { offer: offerStore, account: accountStore, branchPlus: branchPlusStore } = useStore();
  const { policies: policesStore } = accountStore;
  const { policy: policyStore } = policesStore;

  return useEffect(() =>
    autorun(async () => {
      if (inOfferEditRoute || inOfferCheckoutRoute || inUWFormRoute) {
        await when(() => !offerStore?.isLoading && offerStore?.primaryNamedInsured);
        if (offerStore?.primaryNamedInsured) {
          document.title = `${brandConstants.SHORT_NAME} Offer For ${offerStore?.primaryNamedInsured}`;
        } else {
          document.title = `${brandConstants.SHORT_NAME} Offer`;
        }
      } else if (inNewQuoteRoute) {
        document.title = `${brandConstants.SHORT_NAME} New Offer`;
      } else if (inPolicyRoute) {
        await when(() => !accountStore?.accountLoading && !policyStore?.loading && policyStore?.policy?.policyType);
        if (accountStore?.fname && accountStore?.lname) {
          if (policyStore?.policyType) {
            document.title = `${brandConstants.SHORT_NAME} ${getPolicyType(policyStore?.policy?.policyType)} Policy For ${accountStore.fname} ${accountStore.lname}`;
          } else {
            document.title = `${brandConstants.SHORT_NAME} Policy For ${accountStore?.fname} ${accountStore?.lname}`;
          }
        } else {
          document.title = `${brandConstants.SHORT_NAME} Policy`;
        }
      } else if (inBranchPlusPolicy) {
        await when(() => !branchPlusStore?.loading && branchPlusStore?.branchPlusPolicy);
        if (branchPlusStore?.branchPlusPolicy && branchPlusStore?.branchPlusPolicy?.customer) {
          document.title = `${brandConstants.SHORT_NAME} Plus Policy For ${branchPlusStore?.branchPlusPolicy?.customer?.firstName} ${branchPlusStore?.branchPlusPolicy?.customer?.lastName}`;
        } else {
          document.title = `${brandConstants.SHORT_NAME} Plus Policy`;
        }
      } else if (inCustomerRoute) {
        await when(() => !accountStore?.accountLoading);
        if (accountStore?.fname && accountStore?.lname) {
          document.title = `${brandConstants.SHORT_NAME} Member ${accountStore?.fname} ${accountStore?.lname}`;
        } else {
          document.title = `${brandConstants.SHORT_NAME} Member`;
        }
      } else if (inToolsRoutes) {
        document.title = `${brandConstants.SHORT_NAME} Internal Tools`;
      } else if (inSearchOffers) {
        document.title = `${brandConstants.SHORT_NAME} Search Offers`;
      } else if (inSearchCustomers) {
        document.title = `${brandConstants.SHORT_NAME} Search Members`;
      } else if (inSearchPolicies) {
        document.title = `${brandConstants.SHORT_NAME} Search Policies`;
      } else if (inAgencyPortal) {
        document.title = `${brandConstants.SHORT_NAME} Portal`;
      } else if (inSignInRoute) {
        document.title = `${brandConstants.SHORT_NAME} Sign In`;
      } else {
        document.title = `${brandConstants.SHORT_NAME} Staff App`;
      }
    })
  );
};
